import { Box, Container, Typography, Paper, useMediaQuery } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import Cta from "src/Component/card-components/Cta";

const DynamicUniversityPage = ({ heading, backgroundImage, content }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box
      id=''
        sx={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("${backgroundImage}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: { xs: "auto", sm: "500px", md: "600px" },
          width: "100%",
          display: "flex",
          alignItems: "center",
          position: "relative",
          padding: 2,
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden"
        }}
      >
        <Container
        maxWidth="1024px"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            zIndex: 2
          }}
        >
          <Box sx={{ flex: 1, textAlign: { xs: "center", sm: "left" } }}>
            <Typography variant={isMobile ? "h6" : "h2"} sx={{ color: "#ffffff", fontWeight: "600" }}>
              {heading}
            </Typography>

            <Box sx={{ my: { xs: 2, sm: 5 }, display: "flex", justifyContent: { xs: "center", sm: "flex-start" } }}>
              <Cta />
            </Box>
          </Box>

          <Paper
            elevation={4}
            sx={{
              flex: 1,
              maxWidth: { xs: "100%", md: "40%" },
              padding: 3,
              borderRadius: "20px",
              backgroundColor: "white",
              opacity: 0.9,
              zIndex: 1,
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "justify",
              overflow: "hidden",
              mt: { xs: 2, md: 0 }
            }}
          >
            <Typography variant="body1" sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
              {content}
            </Typography>
          </Paper>
        </Container>
      </Box>

    </>
  );
};

export default DynamicUniversityPage;
